import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const ReimbursementPurposeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const statusOptions: ComboboxFilterOption<string>[] = [
    { label: 'Medical', value: 'medical' },
    { label: 'Dental', value: 'dental' },
    { label: 'Vision', value: 'vision' },
    { label: 'QME', value: 'qme' },
    { label: 'Premium', value: 'premium' },
  ]

  const filteredOptions = statusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Purpose', options: filteredOptions || [] }]}
        placeholder='Search purposes to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={statusOptions || []}
          noSelectionText='Purpose'
          pluralIdentifier='purposes'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default ReimbursementPurposeFilter
